<template>
  <EuiBlock id="logs_mail" title="Résultat">
    <EuiHeading v-if="getterIsLoading " :level="2">En cours de chargement</EuiHeading>
    <span v-else-if="getterResults.messages !== undefined && getterResults.messages.length === 0">Aucun résultat</span>
    <EuiAdvancedTable ref="content" v-else-if="getterResults.messages !== undefined" v-model="getterResults.messages" style="overflow:hidden">
      <EuiATableRow   slot="tableRow" slot-scope="{ item }" >
        <EuiATableCell label="Date">{{ mixinsDateLocaleToDisplay(item.message.timestamp) }}</EuiATableCell>
        <EuiATableCell label="To">{{ extractFieldTo(item.message.message) }}</EuiATableCell>
        <EuiATableCell label="Message">{{ item.message.message }}</EuiATableCell>
        <EuiATableCell label="Status" >
          <EuiChip
              class="mx-auto"
              :class="`mailStatus_${extractFieldStatus(item.message.message)}`"
              :text="`${ extractFieldStatus(item.message.message) }`"
              />
        </EuiATableCell>
      </EuiATableRow>
    </EuiAdvancedTable>
  </EuiBlock>

</template>

<script>
import dates from '@/mixins/dates';
import { mapGetters } from 'vuex';

export default {
  name: 'components.logs.resultMails',
  mixins: [dates],
  computed: {
    ...mapGetters({
      getterResults: 'logs/result',
      getterIsLoading: 'application/isLoading',
    }),
  },
  methods: {
    extractFromMessage(regex, value) {
      const match = regex.exec(value);
      if (match !== null && match.length > 1) {
        if (match[1] === 'bounced' || match[1] === 'deferred') {
          return 'error';
        }
        return match[1];
      }
      return 'none';
    },
    extractFieldTo(value) {
      return this.extractFromMessage(/.*to=<([\w@\d.]*)>/, value);
    },
    extractFieldStatus(value) {
      if (value.includes('warning')) { return 'warning'; }
      return this.extractFromMessage(/.*status=(\w*)/, value);
    },
    // Need to integrate this route
    // curl -X POST -u 1ejtoacl9k5bm8vdbht3p1tk3e8kqm4bj384g5vsmgf0hb9ditke:token -H 'X-Requested-By: cli' -H 'Accept: application/json' https://graylog.edoc.fr/api/views/search/617ac8947dacc152362df463/execute
  },
};
</script>
